var map = {
	"./IMG_0518_4_11zon.jpg": 6765,
	"./IMG_0524_5_11zon.jpg": 5273,
	"./IMG_0526_6_11zon.jpg": 5036,
	"./IMG_0528_7_11zon.jpg": 3491,
	"./IMG_0531_8_11zon.jpg": 1826,
	"./IMG_0544_9_11zon.jpg": 7983,
	"./IMG_0546_10_11zon.jpg": 8021,
	"./IMG_0576_11_11zon.jpg": 8959
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2818;